import { RequestHelper } from 'utils';
import { API_ROUTES } from 'utils/constants';

const moveStructureLevel = (moveData) => RequestHelper.PUT(API_ROUTES.STRUCTURE_LEVEL.MOVE(), moveData);

export const StructureLevelService = {
  moveStructureLevel
};
